/**
* @ngdoc directive
* @name Animate Click
*
* @description
  Animate block on click
*
* @example
  <div class='action-row btn-shaded' animate-click>Some label</div>
*/

(function() {
  'use strict';

  directive.$inject = ["$timeout"];
  app.directive('animateClick', directive);

  function directive ($timeout) {
    return {
      link: link,
      restrict: 'A',
      scope: {}
    };

    function link($scope, $element) {
      var eventType = ('ontouchstart' in document.documentElement) ? 'touchstart' : 'click';

      $element.on(eventType, function() {
        $element.addClass('mod-click');
        $timeout(function() {
          $element.removeClass('mod-click');
        }, 600);
      });
    }
  }
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/animateClick.js